import React from 'react';
import Link from 'gatsby-link';
import classnames from 'classnames';

import Memory from '../../../components/memory';

export default ({ memories = [] }) => (
  <div>
    {!memories.length ? (
      <div>
        <p>No one has added a memory related to this object yet.</p>
      </div>
    ) : (
      <ul>
        {memories.map((memoryDetails, index) => (
          <li key={index}>
            <Memory {...memoryDetails} />
          </li>
        ))}
      </ul>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/memories/index.js